// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yPE6","badges":"styles_badges__253tS"};